import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'
import {ApplyTitle, FirstPageDiv, HeaderArea, HeaderAreaBox} from './NatAdminApplicatioPrintCommonStyle'
import {getPrintDate} from '../../helper/NatApplicationHelper'
import {RESIDENT_APPLY_PROCESS, RESIDENT_APPLY_STATUS, USER_ATTRIBUTE} from '../../../../../../CodeMaster'
import {NatSealField, SealField} from './NatSealField'
import {NatBicycleParkingUseApplyDetail} from '../../../repository/NatGetBicycleParkingUseApply'
import moment from 'moment'
import {ApplyStatusInfo} from '../../../repository/NatGetApplicationStatus'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'

interface Props {
    bicycleParkingApplicationFormParam: NatBicycleParkingUseApplyDetail
    applyStatusInfoList: ApplyStatusInfo[]
}

export const NatBicycleParkingApplicationDocument: React.FC<Props> = props => {
    const {
        applyStatusInfoList
    } = props

    const {
        applyId, applyStatus, applyDate,
        condominiumName, ridgeName, roomNumber, applicantFamilyName, applicantFirstName,
        useArea, useStartDate, userFamilyName, userFirstName, userAttribute,
        ownerFamilyName, ownerFirstName, bicycleRegistrationNumber
    } = props.bicycleParkingApplicationFormParam

    const userAttributeLabel = (userAttribute) ?
        USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label : ''

    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`
    const userName = `${userFamilyName} ${userFirstName} （${userAttributeLabel}）`
    const ownerName = `${ownerFamilyName} ${ownerFirstName}`
    const bicycleRegistrationNumberText = (bicycleRegistrationNumber) ?
        bicycleRegistrationNumber : '※任意項目のため未入力'

    return (<>
        <FirstPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>自転車置場使用申請書</ApplyTitle></Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'3mm'}>
                        {renderSealField(applyStatusInfoList)}
                    </Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box ml={'25mm'} mt={'3mm'}>
                理事長殿
            </Box>
            <Box ml={'30mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　私は、本マンション自転車置場を使用したいので、自転車置場使用規則に掲げる<br/>
                収容可能な自転車の規格を確認のうえ、本書を提出いたします。
            </Box>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>1  申請者</Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('部屋番号', applicantRoom)}
                        {renderApplicationDetail('氏名', applicantName)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('2  使用区画', useArea)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('3  使用開始日', renderUseStartDate(useStartDate))}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('4  使用者', userName)}
                    </Box>
                </Box>
                <Box mb={'5mm'}>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>5  自転車詳細</Box>
                    <Box ml={'8mm'}>
                        {renderApplicationDetail('所有者', ownerName)}
                        {renderApplicationDetail('自転車登録番号\n' + ' （防犯登録番号）',
                            bicycleRegistrationNumberText)}
                    </Box>
                </Box>
            </Box>
        </FirstPageDiv>
    </>)

    NatBicycleParkingApplicationDocument.displayName = 'NatBicycleParkingApplicationDocument'
}

const renderApplicationDetail = (title: string, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value}/>
        </PrintApplicationDetailContainer>
    )
}

const renderUseStartDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.day}</Box>日
        </>
    )
}

const renderSealField = (applyStatusInfoList: ApplyStatusInfo[]) => {
    const sealFields: SealField[] = applyStatusInfoList.map((info) => {
        const applyStatusEnum = RESIDENT_APPLY_PROCESS.codeToEnumConstants(info.applyProcess)
        let seal
        if (info.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
            seal = '却下'
        } else {
            seal = info.actual.registerDatetime ? moment(info.actual.registerDatetime).format('YYYY/M/D') : ''
        }
        return {
            applyStatus: applyStatusEnum.label,
            seal: seal,
            sortOrder: applyStatusEnum.displayOrder
        }
    });

    return (
        <NatSealField sealFields={sealFields}/>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`
